<div class="address-history-widget">

  <div class="address-history-list">
    @for (_entry of addressHistoryArray.controls; track $index; let index = $index) {
    <div class="address-history-section" [formGroup]="getAddressEntryControl(index)">

      <!-- Previous Address Subheader -->
      @if (renderedPreviousAddressSubheaderText && index > 0) {
      <div [innerHTML]="renderedPreviousAddressSubheaderText | safeHtml"></div>
      }

      <div class="address-widget-container">
        <ng-container *ngComponentOutlet="
            addressWidgetComponent;
            injector: getAddressWidgetInjector(index);
            inputs: getAddressWidgetInputs(index)
          "></ng-container>
      </div>
    </div>
    }
  </div>

  <ng-template #moveInDateTemplate let-index="index" let-entryForm="entryForm">
    <div [formGroup]="entryForm">
      @if (moveInDateLabel) {
      <div class="d-flex">
        <span class="labelText labelIdle labelConfig" [ngStyle]="colorTextAlignStyle">
          {{moveInDateLabel}}
        </span>
      </div>
      }
      <finxone-datepicker [id]="'moveInDate-' + index" [name]="'moveInDate-' + index" formControlName="moveInDate"
        [dayFormControl]="getDayControl(index)" [monthFormControl]="getMonthControl(index)"
        [yearFormControl]="getYearControl(index)" [dateFormat]="selectedDatePickerType" [showErrors]="true"
        [formControlInvalid]="isMoveInDateInvalid(index)"
        [validationConfig]="moveInDateValidationConfig"></finxone-datepicker>
    </div>
  </ng-template>

  @if (shouldShowCoverageError()) {
  <div class="text-error mt-2">
    <p>{{ coverageErrorMessage }}</p>
  </div>
  }
</div>